import { normalizarTexto } from '../../lib/textoBR'

interface Props {
  id: string
  rotulo: string
  valor: string
  aoMudar: (nome: string) => void
  // `undefined` = a consulta ainda esta respondendo, e NAO e o mesmo que lista
  // vazia: dizer "nenhuma tabela" antes da resposta seria mentira piscando.
  existentes: string[] | undefined
}

// O campo que pergunta o nome da tabela de preco. Ele existe em DOIS lugares do
// fluxo de importacao -- a tela inicial e o passo da condicao que sobrou -- e
// esse e exatamente o motivo de ser um componente so.
//
// 18/08/2026: a lista visivel foi publicada so na tela inicial, e o
// representante avisou na mesma tarde: "na primeira escolha da tabela apareceu,
// nas outras 2 nao". O passo da condicao nem a frase "vai criar/vai atualizar"
// tinha. Duas telas do mesmo dado divergem sozinhas; uma so, nao.
//
// ⚠ Nao voltar a duplicar isto. Se a terceira tela pedir nome de tabela, ela usa
// este componente.
export default function CampoNomeDeTabela({ id, rotulo, valor, aoMudar, existentes }: Props) {
  const listaId = `${id}-existentes`
  const jaExiste = existentes?.some((nome) => normalizarTexto(nome) === normalizarTexto(valor))

  return (
    <div>
      <label className="block text-sm text-slate-600 mb-1" htmlFor={id}>
        {rotulo}
      </label>
      <input
        id={id}
        list={listaId}
        value={valor}
        onChange={(e) => aoMudar(e.target.value)}
        placeholder="Digite o nome (nova ou existente)"
        className="w-full border border-slate-300 rounded-lg px-3 py-2"
      />
      {/* O <datalist> continua: no computador ajuda quem digita. Mas ele e um
          MENU, e navegador de celular pode nao abrir menu nenhum -- por isso
          nunca pode ser o unico caminho para os nomes. */}
      <datalist id={listaId}>
        {existentes?.map((nome) => <option key={nome} value={nome} />)}
      </datalist>
      {existentes && (existentes.length > 0 ? (
        // Rotulo E cor de acao: sem os dois, a 360px isto se le como etiqueta e
        // nao como coisa que se toca. Tocar preenche o nome EXATO, que e o que
        // decide entre atualizar a tabela e criar uma nova sem querer.
        // `flex-wrap`: tres nomes reais nao cabem lado a lado em 360px.
        <div className="mt-2">
          <p className="text-xs text-slate-500 mb-1">Já existem — toque para usar:</p>
          <div className="flex flex-wrap gap-1.5">
            {existentes.map((nome) => (
              <button
                key={nome}
                type="button"
                onClick={() => aoMudar(nome)}
                className="text-xs bg-teal-50 text-teal-800 border border-teal-300 rounded-full px-2.5 py-1"
              >
                {nome}
              </button>
            ))}
          </div>
        </div>
      ) : (
        // Aponta a BOLINHA, e nao um botao "Sincronizar": o texto da barra muda
        // com o estado (Sincronizado, Offline, "3 nao subiram"); a bolinha esta
        // sempre la.
        <p className="text-xs text-slate-500 mt-2">
          Nenhuma tabela desta fornecedora neste aparelho. Se você já importou uma, toque
          na bolinha de sincronização no alto da tela e espere ficar verde.
        </p>
      ))}
      {valor.trim() && (
        <p className="text-xs text-slate-500 mt-1">
          {jaExiste
            ? `✎ vai atualizar a tabela «${valor.trim()}»`
            : `＋ vai criar a tabela «${valor.trim()}»`}
        </p>
      )}
    </div>
  )
}
